<template>
  <div class="multilayer with-slider">
    <slider-select
      v-if="fields[MultilayerBagsFields.type].options?.length"
      v-model="form.type"
      class="main-slider"
    >
      <slider-select-option
        v-for="option in fields[MultilayerBagsFields.type].options"
        :key="option.value"
        :value="option.value"
        :label="option.title"
        :image-src="uploadsUrl(option?.thumbnail?.data?.attributes.url || '')"
      />
    </slider-select>
    <i-form
      v-scroll-to-invalid
      class="multilayer-form w-full"
      name="multilayer-form"
      @submit="handleSubmit"
    >
      <div class="type">
        <strapi-label :label="labels[MultilayerBagsLabels.type]" />
        <div class="form-field-group">
          <!--type field-->
          <zaproo-select
            v-if="fields[MultilayerBagsFields.type]"
            v-model="form.type"
            :removable="false"
            searchable
            highlight
            :no-result-label="$t('No results found')"
            no-result-class="text-neutral-900/50 text-center !py-2 !px-4"
            name="type"
            :rules="fieldRules[MultilayerBagsFields.type]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[MultilayerBagsFields.type]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[MultilayerBagsFields.type].options"
              :key="option.value"
              :value="option.value"
              :label="option.title"
            />
          </zaproo-select>
        </div>
      </div>
      <div
        v-if="fields[MultilayerBagsFields.type]?.options?.length"
        class="form-slider"
      >
        <slider-select v-model="form.type">
          <slider-select-option
            v-for="option in fields[MultilayerBagsFields.type].options"
            :key="option.value"
            :value="option.value"
            :label="option.value"
            :image-src="
              uploadsUrl(option?.thumbnail?.data?.attributes.url || '')
            "
          />
        </slider-select>
      </div>
      <div class="dimensions mt-6">
        <strapi-label :label="labels[MultilayerBagsLabels.dimensions]" />
        <div class="form-field-third">
          <zaproo-input
            v-for="d in dimensions"
            :key="d.name"
            v-model="form[d.name]"
            type="number"
            :name="d.name"
            :placeholder="d.placeholder"
            :description="d.description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label :field="d.field" />
            </template>
          </zaproo-input>
        </div>
        <div class="form-field-checkbox-group">
          <zaproo-checkbox
            v-for="option in fields[MultilayerBagsFields.typeAdditional]
              .options"
            :key="option.value"
            :model-value="form.typeAdditional.includes(option.value)"
            :name="option.value"
            @update:model-value="
              toggleInArray(form.typeAdditional, option.value, $event)
            "
          >
            <special-order-form-input-label
              class="!mt-0"
              :field="{ title: option.title }"
            />
          </zaproo-checkbox>
        </div>
      </div>
      <div class="color mt-6">
        <strapi-label :label="labels[MultilayerBagsLabels.color]" />
        <div class="form-field-group">
          <zaproo-input
            v-model="form.mainColor"
            type="text"
            :name="MultilayerBagsFields.mainColor"
            :rules="fieldRules[MultilayerBagsFields.mainColor]"
            :placeholder="fields[MultilayerBagsFields.mainColor].placeholder"
            :description="fields[MultilayerBagsFields.mainColor].description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[MultilayerBagsFields.mainColor]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>
      <div class="color mt-6">
        <strapi-label :label="labels[MultilayerBagsLabels.product]" />
        <div class="form-field-group">
          <zaproo-input
            v-model="form.packageableProduct"
            type="text"
            :name="MultilayerBagsFields.packageableProduct"
            :rules="fieldRules[MultilayerBagsFields.packageableProduct]"
            :placeholder="
              fields[MultilayerBagsFields.packageableProduct].placeholder
            "
            :description="
              fields[MultilayerBagsFields.packageableProduct].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[MultilayerBagsFields.packageableProduct]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>
      <div class="color mt-6">
        <strapi-label :label="labels[MultilayerBagsLabels.print]" />
        <div class="form-field-group">
          <zaproo-select
            v-if="fields[MultilayerBagsFields.printSelect]"
            v-model="form.printSelect"
            :removable="false"
            name="type"
            :rules="fieldRules[MultilayerBagsFields.printSelect]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[MultilayerBagsFields.printSelect]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[MultilayerBagsFields.printSelect].options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.title }}
            </zaproo-select-option>
          </zaproo-select>
        </div>

        <div class="form-field-group">
          <zaproo-file-input
            v-if="isPrintDesignFile"
            v-model="form.designFile"
            class="form-file-field mt-3"
            name="designFiles"
            multiple
            :rules="fieldRules[MultilayerBagsFields.designFile]"
            :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
            :placeholder="fields[MultilayerBagsFields.designFile].placeholder"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[MultilayerBagsFields.designFile]"
              />
            </template>
            <template #removeFileText>
              <icons-icon-trash />
              {{ $t("Remove") }}
            </template>
            <template #fileError="{ errors, clear }">
              <div class="mb-2 grid grid-cols-1 gap-2">
                <file-input-error-notification
                  :clear="clear"
                  :errors="errors"
                />
              </div>
            </template>
          </zaproo-file-input>
        </div>
      </div>
      <special-order-form-general-contacts-part
        v-model="form"
        class="general-contacts-form"
        :loading="loading"
      >
        <zaproo-input
          v-model="form.amountPcs"
          type="number"
          name="amountPcs"
          :rules="fieldRules[MultilayerBagsFields.amountPcs]"
          :placeholder="fields[MultilayerBagsFields.amountPcs].placeholder"
          :description="fields[MultilayerBagsFields.amountPcs].description"
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[MultilayerBagsFields.amountPcs]"
            />
          </template>
        </zaproo-input>
      </special-order-form-general-contacts-part>
    </i-form>
  </div>
</template>

<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../../SpecialOrderForm/SpecialOrderFormInputLabel.vue";
import { MultilayerBagsFields, MultilayerBagsLabels } from "./types";
import { dimensionsInput } from "./variables";
import {
  StrapiField,
  StrapiLabel as StrapiLabelType,
  StrapiSpecialOrders,
} from "~/types/strapi";
import {
  getCheckboxGroupDefaultModel,
  getFieldDefaultModel,
} from "~/modules/special-orders/helpers";
import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { uploadsUrl } = useStrapiExtend();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);
const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

const labels = computed(() => labelCollection(MultilayerBagsLabels));
const fields = computed(() => fieldsCollection(MultilayerBagsFields));
const fieldRules = useSpecialOrderFieldRules<typeof MultilayerBagsFields>(
  fields.value,
);

const form = ref<ReturnType<typeof resetForm>>(resetForm());

const dimensions = computed(() =>
  dimensionsInput.map((dimension) => ({
    name: dimension,
    required: fields.value[MultilayerBagsFields[dimension]],
    placeholder: fields.value[MultilayerBagsFields[dimension]].placeholder,
    description: fields.value[MultilayerBagsFields[dimension]].description,
    field: fields.value[MultilayerBagsFields[dimension]],
  })),
);

const isPrintDesignFile = computed<boolean>(
  () => form.value.printSelect !== "0",
);

function resetForm() {
  return {
    type: getFieldDefaultModel(fields.value[MultilayerBagsFields.type]),
    length: getFieldDefaultModel(fields.value[MultilayerBagsFields.length]),
    width: getFieldDefaultModel(fields.value[MultilayerBagsFields.width]),
    folding: getFieldDefaultModel(fields.value[MultilayerBagsFields.folding]),
    mainColor: getFieldDefaultModel(
      fields.value[MultilayerBagsFields.mainColor],
    ),
    packageableProduct: getFieldDefaultModel(
      fields.value[MultilayerBagsFields.packageableProduct],
    ),
    printSelect: getFieldDefaultModel(
      fields.value[MultilayerBagsFields.printSelect],
    ),
    designFile: [],
    typeAdditional: getCheckboxGroupDefaultModel(
      fields.value[MultilayerBagsFields.typeAdditional],
    ),
    amountPcs:
      getFieldDefaultModel(fields.value[MultilayerBagsFields.amountPcs]) || "",
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

function toggleInArray(array: any[], key: string, val: boolean): void {
  if (!val && array.includes(key)) {
    array.splice(array.indexOf(key), 1);
  } else if (val && !array.includes(key)) {
    array.push(key);
  }
}

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

useFormFieldCleaner(
  {
    designFile: {
      default: () => [],
      ref: isPrintDesignFile,
    },
  },
  form,
);
</script>
